<template>
  <div class="appointments-page">
    <van-nav-bar title="预约患者" left-arrow @click-left="onClickLeft">
      <template #right>
        <van-icon name="search" size="18" @click="showSearch = !showSearch" />
      </template>
    </van-nav-bar>
    
    <van-search
      v-model="searchForm.patientName"
      placeholder="搜索患者姓名"
      v-show="showSearch"
      @search="onSearch"
      @clear="onSearch"
    />
    
    <van-tabs v-model="activeTab" @change="onTabChange">
      <van-tab title="今日预约" name="today">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="loadList"
          >
            <div class="appointment-list">
              <van-cell-group v-for="item in list" :key="item.appointmentId" class="appointment-item">
                <van-cell :title="item.patientName" :label="'手机号：' + item.patientPhone" is-link @click="showDetail(item)">
                  <template #default>
                    <van-tag :type="getStatusType(item.status)">{{ getStatusText(item.status) }}</van-tag>
                  </template>
                </van-cell>
                <van-cell>
                  <template #title>
                    <div class="info-row">
                      <span>预约时间：{{ item.appointmentDate }} {{ formatTime(item.startTime) }}-{{ formatTime(item.endTime) }}</span>
                    </div>
                    <div class="info-row" v-if="item.patientIdCard">
                      <span>身份证号：{{ item.patientIdCard }}</span>
                    </div>
                  </template>
                </van-cell>
              </van-cell-group>
            </div>
          </van-list>
        </van-pull-refresh>
      </van-tab>
      
      <van-tab title="全部预约" name="all">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="loadList"
          >
            <div class="appointment-list">
              <van-cell-group v-for="item in list" :key="item.appointmentId" class="appointment-item">
                <van-cell :title="item.patientName" :label="'手机号：' + item.patientPhone" is-link @click="showDetail(item)">
                  <template #default>
                    <van-tag :type="getStatusType(item.status)">{{ getStatusText(item.status) }}</van-tag>
                  </template>
                </van-cell>
                <van-cell>
                  <template #title>
                    <div class="info-row">
                      <span>预约时间：{{ item.appointmentDate }} {{ formatTime(item.startTime) }}-{{ formatTime(item.endTime) }}</span>
                    </div>
                    <div class="info-row" v-if="item.patientIdCard">
                      <span>身份证号：{{ item.patientIdCard }}</span>
                    </div>
                  </template>
                </van-cell>
              </van-cell-group>
            </div>
          </van-list>
        </van-pull-refresh>
      </van-tab>
    </van-tabs>
    
    <van-popup v-model="showDetailPopup" position="bottom" round>
      <div class="detail-popup">
        <div class="detail-title">预约详情</div>
        <van-cell-group>
          <van-cell title="患者姓名" :value="currentItem.patientName" />
          <van-cell title="手机号" :value="currentItem.patientPhone" />
          <van-cell title="身份证号" :value="currentItem.patientIdCard || '未填写'" />
          <van-cell title="预约日期" :value="currentItem.appointmentDate" />
          <van-cell title="预约时段" :value="formatTime(currentItem.startTime) + '-' + formatTime(currentItem.endTime)" />
          <van-cell title="排队序号" :value="currentItem.queueNum" />
          <van-cell title="状态">
            <template #default>
              <van-tag :type="getStatusType(currentItem.status)">{{ getStatusText(currentItem.status) }}</van-tag>
            </template>
          </van-cell>
        </van-cell-group>
        <div class="detail-actions" v-if="currentItem.status === '0'">
          <van-button type="primary" block @click="handleVisit(currentItem)">标记已就诊</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'DoctorAppointments',
  data() {
    return {
      activeTab: 'today',
      showSearch: false,
      searchForm: {
        patientName: ''
      },
      loading: false,
      finished: false,
      refreshing: false,
      list: [],
      pageNum: 1,
      pageSize: 10,
      doctorId: null,
      showDetailPopup: false,
      currentItem: {}
    }
  },
  created() {
    var type = this.$route.query.type || 'today';
    this.activeTab = type;
    
    var user = this.$tool.getDoctorUser();
    if (user && user.doctorInfo && user.doctorInfo.doctorId) {
      this.doctorId = user.doctorInfo.doctorId;
    } else {
      this.$toast.fail('请先绑定医生身份');
      this.$router.replace('/doctor/index');
    }
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    onTabChange() {
      this.pageNum = 1;
      this.list = [];
      this.finished = false;
      this.loadList();
    },
    onRefresh() {
      this.pageNum = 1;
      this.finished = false;
      this.loadList();
    },
    onSearch() {
      this.pageNum = 1;
      this.list = [];
      this.finished = false;
      this.loadList();
    },
    loadList() {
      if (!this.doctorId) {
        this.finished = true;
        this.loading = false;
        this.refreshing = false;
        return;
      }
      
      var params = {
        doctorId: this.doctorId,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        patientName: this.searchForm.patientName
      };
      
      if (this.activeTab === 'today') {
        var today = this.formatDate(new Date());
        params.appointmentDate = today;
      }
      
      this.$http.get(this.$Api.doctorAppointmentList, { params: params }).then(res => {
        this.loading = false;
        this.refreshing = false;
        
        var rows = res.data.rows || [];
        if (this.pageNum === 1) {
          this.list = rows;
        } else {
          this.list = this.list.concat(rows);
        }
        
        if (rows.length < this.pageSize) {
          this.finished = true;
        } else {
          this.pageNum++;
        }
      }).catch(() => {
        this.loading = false;
        this.refreshing = false;
        this.finished = true;
      });
    },
    formatDate(date) {
      var year = date.getFullYear();
      var month = (date.getMonth() + 1).toString();
      var day = date.getDate().toString();
      var monthStr = month.length === 1 ? '0' + month : month;
      var dayStr = day.length === 1 ? '0' + day : day;
      return year + '-' + monthStr + '-' + dayStr;
    },
    formatTime(time) {
      if (!time) return '';
      if (typeof time === 'string') {
        return time.substring(0, 5);
      }
      return time;
    },
    getStatusType(status) {
      switch (status) {
        case '0': return 'primary';
        case '1': return 'success';
        case '2': return 'default';
        default: return 'default';
      }
    },
    getStatusText(status) {
      switch (status) {
        case '0': return '待就诊';
        case '1': return '已就诊';
        case '2': return '已取消';
        default: return '未知';
      }
    },
    showDetail(item) {
      this.currentItem = item;
      this.showDetailPopup = true;
    },
    handleVisit(item) {
      this.$dialog.confirm({
        title: '确认',
        message: '确认将此预约标记为已就诊？'
      }).then(() => {
        this.$http.put(this.$Api.doctorAppointmentVisit, {
          appointmentId: item.appointmentId
        }).then(res => {
          if (res.data.code === 200) {
            this.$toast.success('操作成功');
            this.showDetailPopup = false;
            this.onRefresh();
          } else {
            this.$toast.fail(res.data.msg || '操作失败');
          }
        }).catch(() => {
          this.$toast.fail('网络错误');
        });
      }).catch(() => {});
    }
  }
}
</script>

<style scoped>
.appointments-page {
  background: #f5f5f5;
  min-height: 100vh;
}
.appointment-list {
  padding: 10px;
}
.appointment-item {
  margin-bottom: 10px;
  border-radius: 8px;
  overflow: hidden;
}
.info-row {
  font-size: 13px;
  color: #666;
  margin-bottom: 4px;
}
.detail-popup {
  padding: 16px;
}
.detail-title {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 16px;
}
.detail-actions {
  margin-top: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/doctor/appointments.vue